<div
  class='ratingsPageWrapper'
>
  <app-ratings-page-header></app-ratings-page-header>
  <app-ratings-page-table></app-ratings-page-table>
</div>
